<template>
	<transition name="fade">
		<div
			v-show="show"
			class="modal-wrapper"
			aria-modal="true"
			tabindex="0"
			@keydown.esc="closeModal"
		>
			<transition name="slide">
				<div v-show="show" class="modal">
					<slot></slot>
				</div>
			</transition>
		</div>
	</transition>
</template>
<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		closeModal() {
			this.$emit('close-modal');
		}
	}
};
</script>
<style lang="scss" scoped>
.fade-enter {
	opacity: 0;
}

.fade-enter-active {
	transition: opacity 0.5s;
}

.fade-leave-active {
	transition: opacity 0.5s;
	opacity: 0;
}

.slide-enter-active {
	-webkit-animation: slide-out 0.5s forwards;
	animation: slide-in 0.5s forwards;
}

.slide-leave-active {
	-webkit-animation: slide-out 0.5s forwards;
	animation: slide-out 0.5s forwards;
}

@keyframes slide-in {
	from {
		-webkit-transform: translateY(50px);
		transform: translateY(50px);
	}
	to {
		-webkit-transform: translateY(0);
		transform: translateY(0);
	}
}

@keyframes slide-out {
	from {
		-webkit-transform: translateY(0);
		transform: translateY(0);
	}
	to {
		-webkit-transform: translateY(50px);
		transform: translateY(50px);
	}
}
</style>
